import { Component, OnInit } from '@angular/core';
import {
  NgbModalConfig,
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-credit-note-upload-preview',
  templateUrl: './credit-note-upload-preview.component.html',
  styleUrls: ['./credit-note-upload-preview.component.scss'],
})
export class CreditNoteUploadPreviewComponent implements OnInit {
  closeResult: string = '';
  modalOptions: NgbModalOptions;

  constructor(private modalService: NgbModal, private router: Router) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      scrollable: true,
    };
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  acceptDeclaration() {
    this.modalService.dismissAll();
    this.router.navigateByUrl('/credit-notes');
  }

  ngOnInit(): void {}
}
